import { inject } from '@angular/core';
import { Observable } from 'rxjs';

import { CLOCKING_REPOSITORY, ClockingRepository } from '@app/domain/repositories/mot/clocking.repository.contract';
import { Clocking } from '@app/entities/models/mot/clocking/clocking.model';

import { ClockingUseCases } from './clocking.use-cases.contract';

export class ClockingUseCasesImpl implements ClockingUseCases {
  #clockingRepository: ClockingRepository = inject(CLOCKING_REPOSITORY);

  getClockings(): Observable<Clocking> {
    return this.#clockingRepository.getClockings();
  }
}
